export const FUNDING_SOURCE_TYPE = {
  CASH: "CASH",
  EQUITY: "EQUITY",
  LETTER_OF_CREDIT: "LETTER_OF_CREDIT",
  LOAN: "LOAN",
  TAX_CREDIT: "TAX_CREDIT",
  WORKING_CAPITAL: "WORKING_CAPITAL",
};
